import * as React from "react"

const SvgTag = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="M11.15 22.429q-.375 0-.75-.15t-.675-.45l-7.15-7.15q-.3-.3-.438-.663a2.06 2.06 0 0 1 0-1.487q.138-.375.438-.675l7.8-7.825q.275-.276.65-.438a1.9 1.9 0 0 1 .775-.162h7.175q.825 0 1.412.587.588.588.588 1.413v7.175a1.98 1.98 0 0 1-.575 1.4l-7.825 7.825q-.3.3-.675.45t-.75.15m0-2 7.825-7.85v-7.15h-7.15L4 13.279zm4.325-10q.624 0 1.063-.438a1.45 1.45 0 0 0 .437-1.062q0-.625-.438-1.063a1.45 1.45 0 0 0-1.062-.437q-.624 0-1.063.437a1.45 1.45 0 0 0-.437 1.063q0 .624.438 1.062.436.438 1.062.438" />
  </svg>
)
export default SvgTag
